import BaseViz from './BaseViz'
import PercentagetBarChart from '../charts/PercentageBarChart'
import PercentageBarDataController from '../viz_behaviors/PercentageBarDataController'
export default class PercentageBarViz extends BaseViz {
  static defaultConfig = {
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical', 'single'],
        nonEditable: true,
        exposed: false
      },
    },
    AxisHelper: {
      x: {
        tickMatchData: {
          nonEditable: true,
          exposed: false
        }
      }
    }
  }
  static chartClass = PercentagetBarChart
  static dataControllerClass = PercentageBarDataController
}
